import { Link } from 'react-router-dom';

import Button from './ui/button';

const FourOFour = () => {
  return (
    <div className="flex h-[calc(100vh-97px)] flex-col items-center justify-center p-4 text-center text-white md:h-[calc(100vh-149px)]">
      <h1 className="text-2xl font-bold">Seems your are lost.</h1>
      <small className="text-slate-500 mb-5">
        The page you are looking for does not exist.
      </small>

      <Link to="/">
        <Button variant="link">go to homepage</Button>
      </Link>
    </div>
  );
};

export default FourOFour;
